import { render, staticRenderFns } from "./CallbackRequests.vue?vue&type=template&id=56593d54&scoped=true"
import script from "./CallbackRequests.vue?vue&type=script&lang=js"
export * from "./CallbackRequests.vue?vue&type=script&lang=js"
import style0 from "./CallbackRequests.vue?vue&type=style&index=0&id=56593d54&prod&scoped=true&lang=css"
import style1 from "./CallbackRequests.vue?vue&type=style&index=1&id=56593d54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56593d54",
  null
  
)

export default component.exports